import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
 return (
  <nav aria-label="breadcrumb">
   <ol className="breadcrumb flex space-x-2 text-gray-600">
    {items &&
     items.map((item, index) => (
      <li key={index} className="breadcrumb-item flex items-center">
       {index !== items.length - 1 ? (
        <>
         <Link to={item.path} className="text-blue-600 hover:underline">
          {item.label}
         </Link>
        </>
       ) : (
        <span className="text-gray-900 font-semibold">{item.label}</span>
       )}
      </li>
     ))}
   </ol>
  </nav>
 );
};

export default Breadcrumb;
